/* istanbul ignore file */
import * as Yup from 'yup';
import messages from 'containers/ContactUsPage/messages';
import { translate } from 'helpers/intl';

export default (props: any) =>
  Yup.object().shape({
    object: Yup.string(),
    message: Yup.string().required(
      translate({ ...messages.requiredField }, props),
    ),
  });
